import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

window.addEventListener("DOMContentLoaded", () => {
    const reviewsCarouselSections = document.querySelectorAll('.reviews-carousel__container');

    if(reviewsCarouselSections.length === 0) {
        return;
    }

    reviewsCarouselSections.forEach(carousel => {
        const elementSwiperReviewsCarousel = carousel.querySelector('.swiper-reviews-carousel');
        const elementSwiperReviewsPlPage = carousel.querySelector('.swiper-reviews-carousel-pl-page');
        let mobileViews = 1.2;
    
        if (carousel.classList.contains('reviews-carousel-simple')) {
            mobileViews = 1;
        }
    
        if(elementSwiperReviewsPlPage) {
            let swiperReviewsCarousel = new Swiper(elementSwiperReviewsPlPage, {
                init: false,
                modules: [Navigation, Pagination],
                spaceBetween: 16,
                rewind: true,
                slidesPerView: mobileViews,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                navigation: {
                    nextEl: '.reviews-carousel__reviews--indicators .arrow.next',
                    prevEl: '.reviews-carousel__reviews--indicators .arrow.prev',
                },
                breakpoints: {
                    520: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 1,
                    },
                    1024: {
                      slidesPerView: 1,
                    }
                }
            })

            swiperReviewsCarousel.init()
        }
        if(elementSwiperReviewsCarousel) {
            let swiperReviewsCarousel = new Swiper(elementSwiperReviewsCarousel, {
                init: false,
                modules: [Navigation, Pagination],
                spaceBetween: 16,
                rewind: true,
                slidesPerView: mobileViews,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                navigation: {
                    nextEl: '.reviews-carousel__reviews--indicators .arrow.next',
                    prevEl: '.reviews-carousel__reviews--indicators .arrow.prev',
                },
                breakpoints: {
                    520: {
                      slidesPerView: 1.6,
                    },
                    768: {
                      slidesPerView: 1,
                    },
                    1024: {
                      slidesPerView: 1,
                    }
                },
                on: {
                    slideChangeTransitionEnd: (e) => {
                        const reviewNumber = e.realIndex + 1;
                        let direction;

                        if (e.realIndex === e.previousRealIndex + 1 || (e.realIndex === 0 && e.previousRealIndex === e.slides.length - 1)) {
                            direction = 'next';
                        } else {
                            direction = 'prev';
                        }

                        // Send event Google Analytics 4
                        gtag('event', 'reviews_carousel_navigation', {
                            carousel_id: 'swiper_reviews_carousel',
                            review_number: reviewNumber,
                            direction: direction
                        });
                    }
                }
            })

            swiperReviewsCarousel.init()
        }
    })
})